export const jwt = {
  type: "string",
  minLength: 1,
  maxLength: 8 * 1024
};
